import { connect } from 'react-redux';
import UpdateNotification from './update-notification';
import { UpdateApplied } from '../actions/update-actions';

const mapStateToProps = (state) => {
  return {
    open: state.notifications.update.open
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdate: () => {
      dispatch(UpdateApplied());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateNotification); 